export default "__VITE_ASSET__ae986237__"